import { Box, Container, Tab, Typography, useMediaQuery, useTheme } from '@mui/material'
import React, { useEffect, useState } from 'react'
import LineChart from './LineChart'
import BarChart from './BarChart'
import DonutChart from './DonutChart'
import ManageBox from './ManageBox'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import Synthese from './Synthese'
import Operations from './Operations'
import SousCategories from './SousCategories'
import { makeGetRequest } from 'utils/api'
import QuestionAnswer from './QuestionAnswer'
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

export default function MonBudget() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'))
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [budgetRevenu, setBudgetRevenu] = React.useState([])
  const [value, setValue] = React.useState('1')
  const [revenuCheck, setRevenuCheck] = React.useState(false)
  const [infoshow, setInfoShow] = useState(true)
  useEffect(() => {
    if (isMobile) {
      setInfoShow(false)
    } else {
      setInfoShow(true)
    }
  }, [isMobile])
  const handleChange = (event, newValue) => {
    if (newValue === '1') {
      fetchCheckReference()
    }
    setValue(newValue)
  }
  useEffect(() => {
    fetchCheckReference()
  }, [])
  const fetchBudgetRevenu = async () => {
    const { data, status } = await makeGetRequest('/api/Finance/get-budgetrevenu/', {}, true)
    if (status === 200) {
      setBudgetRevenu(data)
    }
  }
  const fetchCheckReference = async () => {
    const { data, status } = await makeGetRequest('/api/Finance/check-reference/', {}, true)
    if (status === 200) {
      if (data > 0) {
        setRevenuCheck(false)
        fetchBudgetRevenu()
      } else {
        setRevenuCheck(true)
      }
    }
  }
  const updatepage = () => {
    fetchBudgetRevenu()
  }
  return (
    <div>
      {revenuCheck ? (
        <QuestionAnswer setRevenuCheck={setRevenuCheck} updatepage={updatepage} />
      ) : (
        <>
          <Box
            display={infoshow ? 'flex' : 'none'}
            overflow={'hidden'}
            flexDirection={isMobile ? 'column' : 'row'}
            minHeight={270}
            bgcolor={'#06162f'}
            width={'100%'}
            alignItems={'center'}
            justifyContent={'center'}
            gap={2}
            sx={{
              borderBottom: '1px solid rgba(255,255,255,0.08)',
              px: { xs: 2, md: 4 },
              py: 3,
            }}
          >
            <Box sx={{ width: '100%', maxWidth: 1280 }}>
              <Typography sx={{ color: '#ffffff', fontSize: 26, fontWeight: 900, mb: 0.5 }}>
                {t('finance.monBudget.pilotageTitle')}
              </Typography>
              <Typography sx={{ color: 'rgba(255,255,255,0.66)', fontSize: 14, mb: 2 }}>
                {t('finance.monBudget.pilotageSubtitle')}
              </Typography>
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: { xs: '1fr', md: '1.15fr 1.15fr 1fr 0.8fr' },
                  gap: 1.5,
                  alignItems: 'stretch',
                }}
              >
                <LineChart linedata={budgetRevenu.filter((e) => e.type === 'budetexpense')[0]?.data} />
                <BarChart bardata={budgetRevenu.filter((e) => e.type === 'classification')[0]?.data} />
                <DonutChart
                  doutdata={budgetRevenu.filter((e) => e.type === 'classification')[0]?.data}
                />
                <ManageBox
                  revenu={budgetRevenu.filter((e) => e.type === 'revenu')[0]?.data}
                  updatepage={updatepage}
                />
              </Box>
            </Box>
          </Box>
          <Box display={'flex'} justifyContent={'center'}>
            {isMobile && (
              <>
                {infoshow ? (
                  <KeyboardArrowUpIcon
                    sx={{
                      color: 'white',
                      bgcolor: 'gray',
                      borderRadius: 5,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setInfoShow(!infoshow)
                    }}
                  />
                ) : (
                  <KeyboardArrowDownIcon
                    sx={{
                      color: 'white',
                      bgcolor: 'gray',
                      borderRadius: 5,
                      cursor: 'pointer',
                    }}
                    onClick={() => {
                      setInfoShow(!infoshow)
                    }}
                  />
                )}
              </>
            )}
          </Box>
          <Container maxWidth="lg" sx={{ mt: 2 }}>
            <TabContext value={value}>
              <Box sx={{ borderBottom: 1, borderColor: 'rgba(255,255,255,0.12)' }}>
                <TabList
                  onChange={handleChange}
                  sx={{
                    '& .MuiTabs-flexContainer': { display: 'block !important' },
                    '& .MuiTabs-indicator': { bgcolor: '#5aa1d8' },
                  }}
                >
                  <Tab sx={{ color: 'white', textTransform: 'none', fontWeight: 800 }} label={t('finance.monBudget.tabSynthese')} value="1" />
                  <Tab sx={{ color: 'white' }} label={t('finance.monBudget.tabOperations')} value="2" />
                  <Tab sx={{ color: 'white' }} label={t('finance.monBudget.tabSubcategoryAllocation')} value="3" />
                </TabList>
              </Box>

              <TabPanel value="1">
                <Synthese budgetRevenu={budgetRevenu} />
              </TabPanel>
              <TabPanel value="2" sx={{ p: 0 }}>
                <Operations />
              </TabPanel>
              <TabPanel value="3" sx={{ p: isMobile ? 0 : 2 }}>
                <SousCategories />
              </TabPanel>
            </TabContext>
          </Container>
        </>
      )}
    </div>
  )
}
